import { debounce } from "./utils";
import { EventEmitter } from "./event-emitter";

/**
 * Breakpoints configuration
 */
const breakpointConfig = { "xl": 1400, "lg": 1200, "md": 992, "sm": 768, "xs": 576 }

/**
 * Class that helps to work with different breakpoints.
 * @class
 */
export class Breakpoints extends EventEmitter {

  /**
   * @constructor
   */
  constructor() {
    if (Breakpoints._instance) {
      return Breakpoints._instance;
    }
    super();
    Breakpoints._instance = this

    this.currentBreakpoint = this.getCurrentBreakpoint();
    window.addEventListener('resize', debounce(this._onWindowResize.bind(this), 250))
  }

  /**
   * Check if the current window is smaller than a given breakpoint
   * @param {string} breakpointName A breakpoint as defined in breakpointConfig
   * @returns {boolean} True if the current window.innerWidth is smaller that the breakpoint
   */
  breakpointDown(breakpointName) {
    return (window.innerWidth < breakpointConfig[breakpointName])
  }

  /**
   * Check if the current window is bigger than a given breakpoint
   * @param {string} breakpointName A breakpoint as defined in breakpointConfig
   * @returns {boolean} True if the current window.innerWidth is bigger thant the breakpoint
   */
  breakpointUp(breakpointName) {
    return (window.innerWidth >= breakpointConfig[breakpointName])
  }

  /**
   * Retrieves the current active breakpoint
   * @returns {string} A breakpoint as defined in breakpointConfig
   */
  getCurrentBreakpoint() {
    let bp = null
    for (const bpName in breakpointConfig) {
      const bpSize = breakpointConfig[bpName];
      if (bpSize > window.innerWidth) {
        bp = bpName;
      }
    }
    return bp;
  }

  /**
   * 
   * @returns {breakpointConfig} Returns the breakpoints with their sizes
   */
  getAll() {
    return breakpointConfig;
  }

  /**
   * Event Listener for window.resize that emits a new event 'breakpoint_changed' with
   * the old and new breakpoint { oldBreakpoint, currentBreakpoint }
   * @fires Breakpoints#breakpoint_changed
   */
  _onWindowResize() {
    const newBreakpoint = this.getCurrentBreakpoint();
    if (this.currentBreakpoint !== newBreakpoint) {
      const oldBreakpoint = this.currentBreakpoint;
      this.currentBreakpoint = newBreakpoint;
      /**
       * Fired when a breakpoint changes
       * @example 
       *  (new Breakpoints()).on('breakpoint_changed', changes => console.log(changes))
       *  // -> { oldBreakpoint: 'xs', currentBreakpoint: 'md' }
       * @event Breakpoints#breakpoint_changed
       * @type {object}
       */
      this.emit('breakpoint_changed', {
        oldBreakpoint,
        currentBreakpoint: this.currentBreakpoint
      })
    }
  }

}